import React from 'react'
import * as UI from 'ui'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import { Translation } from '@morningtrain/react-translations'
import WhenMultipleDepartmentsAreSelected from 'support/conditionals/WhenMultipleDepartmentsAreSelected'
import * as Displays from 'support/displays'

function RevenueChartTooltipInner (props) {
  if (!props) {
    return null
  }

  const freshForecast = !isNaN(parseFloat(props.fresh_forecast)) ? parseFloat(props.fresh_forecast) : 0
  const lockedForecast = !isNaN(parseFloat(props.locked_forecast)) ? parseFloat(props.locked_forecast) : 0
  const revenue = !isNaN(parseFloat(props.total_revenue)) ? parseFloat(props.total_revenue) : 0
  const byDepartment = props.by_department || []

  return (
    <UI.Card tight className='p-4'>

      <WhenMultipleDepartmentsAreSelected>

        <UI.VerticalList>
          <UI.WithSubtitle subtitle={(
            <UI.Text uppercase size='xs'>
              Total <Translation name='generic.revenue' />
            </UI.Text>
          )}
          >
            <UI.Text size='base'>
              {revenue.toLocaleString()} kr.
            </UI.Text>
          </UI.WithSubtitle>

          {
              <>
                <table>
                  {byDepartment.map(byDepartmentEntry => {
                    return (
                      <tr key={byDepartmentEntry.id}>
                        <td className='pr-6'>
                          <UI.Text weight='medium'>
                            {byDepartmentEntry.name}
                          </UI.Text>
                        </td>
                        <td align='right'>
                          <Displays.Currency defaultValue={byDepartmentEntry.revenue} decimals={0} />
                        </td>
                      </tr>
                    )
                  })}
                </table>
              </>
              }

        </UI.VerticalList>
      </WhenMultipleDepartmentsAreSelected>

      <WhenMultipleDepartmentsAreSelected negate>
        <UI.VerticalList>
          <UI.WithSubtitle subtitle={(
            <UI.Text uppercase size='xs'>
              <Translation name='smartviews.schedule_period_summary.revenue' />
            </UI.Text>
          )}
          >
            <UI.Text size='base'>
              {revenue.toLocaleString()} kr.
            </UI.Text>
          </UI.WithSubtitle>

          {(props.hourly)
            ? null
            : (
              <>
                <Can permission={Permissions.SHIFTS_ADJUST_FORECAST}>
                  <UI.WithSubtitle subtitle={(
                    <UI.Text uppercase size='xs' className='tracking-wider'>
                      <Translation name='smartviews.schedule_period_summary.forecast' />
                    </UI.Text>
                  )}
                  >
                    <UI.Text size='sm'>
                      {freshForecast.toLocaleString()} kr.
                    </UI.Text>
                  </UI.WithSubtitle>

                  <UI.WithSubtitle subtitle={(
                    <UI.Text uppercase size='xs' className='tracking-wider'>
                      <Translation name='smartviews.schedule_period_summary.locked_budget' />
                    </UI.Text>
                  )}
                  >
                    <UI.Text size='sm'>
                      {lockedForecast.toLocaleString()} kr.
                    </UI.Text>
                  </UI.WithSubtitle>
                </Can>
                <Can permission={Permissions.SHIFTS_ADJUST_FORECAST} negate>
                  <UI.WithSubtitle subtitle={(
                    <UI.Text uppercase size='xs' className='tracking-wider'>
                      <Translation name='smartviews.schedule_period_summary.forecast' />
                    </UI.Text>
                  )}
                  >
                    <UI.Text size='sm'>
                      {lockedForecast.toLocaleString()} kr.
                    </UI.Text>
                  </UI.WithSubtitle>
                </Can>
              </>
              )}

        </UI.VerticalList>
      </WhenMultipleDepartmentsAreSelected>
    </UI.Card>
  )
}

export default React.memo(RevenueChartTooltipInner)
